import ThreeDots from './ThreeDots';
import ThreeDotsRed from './ThreeDotsRed';

export default ThreeDots;
export {
  ThreeDotsRed
};
